<template>
  <div class="content-wrapper" v-if="modalBehavior.showModalNpiSearch">
    <!--<save-modal-progress-bar :checkTwo="true" :currentCheck=2></save-modal-progress-bar>-->

    <ul class="list content">
      <!-- if no npi found -->
      <li v-if="npiSearchResults.length === 0">
        <h1 class="warning__title">Sorry, we couldn't find provider {{searchNpiForm.first}} {{searchNpiForm.last}}</h1>
      </li>

      <!-- render npi data -->
      <li v-else v-for="(npi, index) in paginateData" :key="index" :value="npi.id" class="list__item capitalize">
        <p>
          <span v-if="npi.first_name"><b>{{ npi.first_name.toLowerCase() }}</b></span>
          <span v-if="npi.middle_name"><b> {{ npi.middle_name.toLowerCase() }}</b></span>
          <span v-if="npi.last_name"><b> {{ npi.last_name.toLowerCase() }}</b></span>
        </p>
        <p>
          <span v-if="npi.address_first_line"><font-awesome-icon icon="map-marker-alt" /> {{ npi.address_first_line.toLowerCase() }}</span>
          <span v-if="npi.address_second_line"> , {{ npi.address_second_line.toLowerCase() }}</span>
          <span v-if="npi.address_city"> , {{ npi.address_city.toLowerCase() }}</span>
          <span v-if="npi.address_state"> , {{ npi.address_state }}</span>
        </p>
        <p><span v-if="npi.phone"><font-awesome-icon icon="phone"/> {{ npi.phone }}</span></p>
        <p><span v-if="npi.fax"><font-awesome-icon icon="fax"/> {{ npi.fax }}</span></p>

        <button class="btn btn-select" @click="selectNpi(npi.id)"
                :class="{selected: npi.id===npiSelected}">
          Select
        </button>
      </li>
    </ul>
    <div v-if="modalNpiSearchWarning" class="">
      <small style="color:#ff4444">* Please select a provider</small>
    </div>
    <!-- pagination -->
    <div v-if="npiSearchResults.length>0">
      <button :disabled="pageNumber === 0"
              @click="prevPage"
              class="btn btn-prev">
        Previous
      </button>

      <button v-for="index in pageCount"
              @click="toPage(index-1)"
              :key="index" class="btn-number" :class="{clicked: index === pageNumber+1}">
        {{index}}
      </button>

      <button :disabled="pageNumber >= pageCount -1"
              @click="nextPage" class="btn btn-next">
        Next
      </button>
    </div>
    <!-- footer -->
    <div class="modal-footer">
      <button type="button" class="btn btn-danger btn--cancel"
              @click="slideModalTo('main')">Go back</button>
      <button type="button" class="btn btn--success" @click="slideModalTo('categorySearch')">Continue</button>
    </div>

  </div>
</template>

<script>
  import {searchNpi, searchCategory} from '@/api/pdfApi';

  export default {
    name: "SaveModalNpiSearch",
    props: {
      modalBehavior: Object,
      npiSearchResults: Array,
      searchNpiForm: Object,
    },
    data() {
      return {
        npiSelected: null,
        modalNpiSearchWarning: false,
        pageNumber: 0,
        size: 3,
      }
    },
    computed: {
      pageCount: function () {
        let l = this.npiSearchResults.length, s = this.size;
        return Math.ceil(l/s);
      },
      paginateData: function () {
        let start = this.pageNumber * this.size, end = start + this.size;
        return this.npiSearchResults.slice(start, end);
      }
    },
    methods: {
      slideModalTo(modal) {
        if (modal === 'main') {
          this.$emit('slideModalTo', modal);
        }
        else if (modal === 'categorySearch') {
          if (this.npiSelected) {
            this.$emit('slideModalTo', modal);
          }
          else {
            this.modalNpiSearchWarning = true;
          }
        }
      },
      selectNpi(npi) {
        this.npiSelected = npi;
        this.$emit('selectNpi', npi);
      },

      // pagination
      nextPage() {
        this.pageNumber++;
      },
      prevPage() {
        this.pageNumber--;
      },
      toPage(pageNumber) {
        this.pageNumber = pageNumber;
      }

    }
  }
</script>

<style scoped lang="scss">
  @import "../../../../stylesheets/modules/extraction-save-modal";
  p {
    margin-bottom: 0.5em;
  }
  .capitalize {
    text-transform: capitalize;
  }
  .padding-5 {
    padding: 5px;
  }
  .list {
    @include flex-box();
    align-items: flex-start;
    padding: 0;
    font-size: 14px;
    margin-bottom: 0;
    list-style-type: none;
  }
  .list__item {
    @include flex(1, 0, 33%);
    position: relative;
    height: 100%;
  }
  .btn {
    font-size: 12px;
    margin-top: 5px;
  }
  .btn-select {
    // position: absolute;
    // bottom: 0;
  }
  .content {
    padding-top: 40px;
  }

  /* pagination */
  .btn-number {
    border: none;
    background-color: transparent;
    cursor: pointer;
    font-size: 0.75em;
  }
  .btn-prev, .btn-next {
    background-color: transparent;

    &:hover {
      background-color: transparent;
    }
  }
  .selected {
    background-color: darken(lightgray, 13%);
  }
  .clicked {
    color: #0060ff;
  }

</style>